import { getRoles, getAlibabaAccounts } from '@/pages/registrations/api/api';

export const ROLES_GETTERS = {
  ADMIN_ROLES: 'adminRoles',
  CONTRIBUTOR_ROLES: 'contributorRoles',
  READER_ROLES: 'readerRoles',
  ALIBABA_ACCOUNTS: 'alibabaAccounts',
};

export const ROLES_ACTIONS = {
  GET_ROLES: 'getRoles',
  GET_ALIBABA_ACCOUNTS: 'getAlibabaAccounts',
};

const ROLES_MUTATIONS = {
  SET_ADMIN_ROLES: 'setAdminRoles',
  SET_CONTRIBUTOR_ROLES: 'setContributorRoles',
  SET_READER_ROLES: 'setReaderRoles',
  SET_ALIBABA_ACCOUNTS: 'setAlibabaAccounts',
};

export default {
  namespaced: true,
  state: {
    adminRoles: [],
    contributorRoles: [],
    readerRoles: [],
    alibabaAccounts: [],
  },
  getters: {
    [ROLES_GETTERS.ADMIN_ROLES]: (state: any) => {
      return state.adminRoles;
    },
    [ROLES_GETTERS.CONTRIBUTOR_ROLES]: (state: any) => {
      return state.contributorRoles;
    },
    [ROLES_GETTERS.READER_ROLES]: (state: any) => {
      return state.readerRoles;
    },
    [ROLES_GETTERS.ALIBABA_ACCOUNTS]: (state: any) => {
      return state.alibabaAccounts;
    },
  },
  mutations: {
    [ROLES_MUTATIONS.SET_ADMIN_ROLES]: (state: any, roles: any) => {
      state.adminRoles = roles;
    },
    [ROLES_MUTATIONS.SET_CONTRIBUTOR_ROLES]: (state: any, roles: any) => {
      state.contributorRoles = roles;
    },
    [ROLES_MUTATIONS.SET_READER_ROLES]: (state: any, roles: any) => {
      state.readerRoles = roles;
    },
    [ROLES_MUTATIONS.SET_ALIBABA_ACCOUNTS]: (state: any, accounts: any) => {
      state.alibabaAccounts = accounts;
    },
  },
  actions: {
    [ROLES_ACTIONS.GET_ROLES]: async (context: any, role: string) => {
      const data = await getRoles(role);
      const roles = [...new Set(data.map((i: any) => ({ label: i.displayName, value: i.displayName })))];
      context.commit(ROLES_MUTATIONS.SET_ADMIN_ROLES, roles);
      context.commit(ROLES_MUTATIONS.SET_CONTRIBUTOR_ROLES, roles);
      context.commit(ROLES_MUTATIONS.SET_READER_ROLES, roles);
    },
    [ROLES_ACTIONS.GET_ALIBABA_ACCOUNTS]: async (context: any, apmid: string) => {
      const data = await getAlibabaAccounts(apmid);
      const accounts = [
        ...new Set(data.map((i: any) => ({ label: i.u_account_id + ` (${i.u_environment})`, value: i.u_account_id }))),
      ];
      context.commit(ROLES_MUTATIONS.SET_ALIBABA_ACCOUNTS, accounts);
    },
  },
};
